import type { Category } from "@/types";

const DEFAULT_LANGUAGE = 'da';

type LocalizationKeys = keyof Category['localizations'][string];

// If the requested key is not found in the specified language, it will fall back to the category name, and if that is also not available, it will return an empty string.
export const getLocalizedCategoryValue = (
  category: Category,
  language: string = DEFAULT_LANGUAGE,
  key: LocalizationKeys
): string => {
  return (
    category.localizations?.[language]?.[key] || category.name ||
    ''
  );
};
